import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  locationTable: {
    '& .MuiTableCell-root': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-paddingNone': {
      color: theme.palette.primary.mainBlue,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: theme.palette.custom.tableRowHover,
      },
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.main,
    },
    '& svg:hover': {
      color: theme.palette.primary.blue,
    },
  },
  title: {
    flexGrow: 1,
    marginBottom: '20px',
  },
  addressTitle: {
    margin: '14px 0',
    fontWeight: '600',
    fontSize: '1.2rem',
  },
  button: {
    width: '140px',
    height: '40px',
    backgroundColor: `${theme.palette.custom.solidButtonBackground} !important`,
    color: `${theme.palette.custom.solidButtonText} !important`,
    borderRadius: '10px',
    marginBottom: '10px',
    marginRight: '10px',
  },
  toolbarTable: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      fontSize: '13px',
      width: '370px',
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.gray,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '2px',
    },
    '& button': {
      backgroundColor: theme.palette.custom.inputBackground,
      color: theme.palette.secondary.gray,
      fontSize: '13.5px',
      '& svg': {
        color: theme.palette.secondary.gray,
      },
      '&:hover': {
        backgroundColor: theme.palette.custom.inputBackground,
        color: theme.palette.secondary.gray,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.custom.menuItemText,
    },
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  filterButton: {
    width: '190px',
    minWidth: '190px',
  },
  popper: {
    zIndex: 2,
    width: '190px',
    '& .MuiPaper-root': {
      width: '100%',
    },
    '& ul': {
      paddingBottom: '0px',
    },
  },
  filterOption: {
    fontSize: '13.5px',
  },
  selectedOption: {
    backgroundColor: 'rgba(44, 157, 201, 0.12) !important',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'rgba(44, 157, 201, 0.2) !important',
    },
  },
  checkIcon: {
    minWidth: '28px',
    color: `${theme.palette.primary.main} !important`,
    '& .MuiSvgIcon-root': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  clearOption: {
    fontSize: '13.5px',
    borderTop: `1px solid ${theme.palette.secondary.gray}`,
  },
  progress: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  locationInfo: {
    display: 'grid',
    gridTemplateColumns: '45% 45%',
    columnGap: '5%',
    padding: '30px',
    '& .MuiFormLabel-root': {
      color: theme.palette.custom.inputLabel,
    },
    '& .MuiFormControl-root': {
      margin: '10px auto',
    },
    '& input': {
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  itemList: {
    fontSize: '13.5px',
    color: theme.palette.custom.menuItemText,
  },
  role: {
    gridColumn: 1,
  },
  select: {
    '& .MuiInputLabel-formControl': {
      transform: 'none',
    },
  },
  selectOulined: {
    marginTop: '26px',
  },
  buttonsContainer: {
    '& button': {
      width: '200px !important',
      borderRadius: '10px',
      color: theme.palette.custom.solidButtonText,
      backgroundColor: theme.palette.custom.solidButtonBackground,
    },
  },
  locations: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  header: {
    display: 'flex',
  },
  tableHeader: {
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  formWrapper: {
    width: '85vw',
  },
  noContent: {
    color: theme.palette.primary.main,
  },
  required: {
    color: theme.palette.custom.errorText,
  },
  modalBox: {
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
    width: '270px',
    '& span': {
      margin: 0,
    },
  },
  uploadIcon: {
    '& svg': {
      paddingTop: '11px',
      height: '50px',
      width: '100%',
      color: theme.palette.custom.iconAccent,
      margin: '0px',
    },
    '& svg:hover': {
      opacity: '0.8',
    },
  },
  input: {
    display: 'none',
  },
  logoUrl: {
    height: '100px',
    width: '100px',
    margin: '10px 20px',
    // Shows through when a location has no image (or the URL 404s, as in the
    // reference screenshot), so it has to invert for dark mode.
    backgroundColor: theme.palette.custom.imagePlaceholderBackground,
  },
  selectModal: {
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 0 20px',
    '& .MuiFormControl-root': {
      width: '300px',
      padding: '10px 0',
    },
  },
  noLocationCreatedNotice: {
    alignSelf: 'center',
    padding: '0 50px 15px',
    color: theme.palette.primary.gray,
    fontSize: '13px',
  },
  buttonsContainerForm: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '30px',
    '& button': {
      width: '200px !important',
      borderRadius: '10px',
      color: theme.palette.custom.solidButtonText,
      backgroundColor: theme.palette.custom.solidButtonBackground,
    },
  },
}));

export default useStyles;
